import React, { useRef, useState } from 'react'
import GenericFormHeaderComponent from '../forms/GenericFormHeaderComponent';
import GenericInput from '../input/GenericInputComponent';
import useCustomToast from '../../hooks/useCustomToast';
import { formatFileSize } from '../../helper/helperTableFunctions';
import GenericFormFooterComponent from '../forms/GenericFormFooterComponent';
import GenericCustomButton from '../GenericCustomButton';
import Icons from '../../assets/icons';
import LanguageTranslator from '../../locals/LanguageTranslator';
import GenericSpinnerLoader from '../../loaders/GenericSpinnerLoader';
import { useSelector } from 'react-redux';

const FileUpload = (props = {}) => {

    const uploadFileRef = useRef();

    const [currentFile, setCurrentFile] = useState(null);

    let {
        heading = "Upload Files",
        filesSupprotedHeading = "",
        fileUploadInputPlaceholder = "Upload File",
        filesSupportedValidationArray = ["*"],
        downloadSampleButtonLabel = "Download Sample",
        downloadSampleButtonUrl = "",
        finalSubmitButtonLabel = "Submit",
        finalSubmitButtonLoading = false,
        submitFile = () => {},
        downloadSampleCustomFunction = () => {},
        downloadSampleCustomComponent = "",
        downloadSampleButtonLoading = false,
    } = props || {};

    const customToast = useCustomToast();

    const uploadFile = (e) => {

        let file = e?.target?.files?.[0];
        let fileName = e?.target?.files?.[0]?.name;

        if (uploadFileRef?.current) {
            uploadFileRef.current.value = null;
        }

        let extension = fileName?.split(".").pop()?.toLowerCase();
        // console.log("file name", fileName, extension);
        console.log("filesSupportedValidationArray", filesSupportedValidationArray, extension);

        if (filesSupportedValidationArray?.includes("*") || filesSupportedValidationArray?.includes(extension?.toLowerCase())) {
            // Check the validation for the file
            setCurrentFile(file ?? null);
        } else {
            customToast({
                title: "File Validation Error!",
                description: `Invalid file selected! Only ${filesSupprotedHeading} are allowed.`,
                status: "error",
            })
        }
    }

    // Function : To download the sample
    const downloadSample = () => {
        if(downloadSampleCustomFunction){
            downloadSampleCustomFunction();
            return;
        }

        window.open("https://staticfiles.supplymint.com/41f457f4-70e5-4e81-ab00-1d3c58aaae32/DATA/COMMENTS/21_02_2025_14_18_30_163.txt?response-content-disposition=inline", "_blank")
    }

    return (
        <div className='uploadBarcodeModal h-full flex flex-col'>
            <GenericFormHeaderComponent
                label={{
                    contentPrimary: heading,
                    contentSecondry: filesSupprotedHeading ?  <><LanguageTranslator>Files Supported</LanguageTranslator> : {filesSupprotedHeading}</> : ""
                }}
                closeModal={props.closeModal}
            />
            <div className="px-[15px] h-full flex flex-col">
                <GenericInput
                    className='!block'
                    genInputExtraClass='h-full upload-item-code'
                    gibInnerClassName='!h-full'
                    inputRef={uploadFileRef}
                    placeholder={fileUploadInputPlaceholder}
                    type="upload"
                    inputKey="uploadFile"
                    onChange={uploadFile}
                    value={null}
                    inputProps={() => ({
                        maxSize: 200,
                        acceptFiles: filesSupportedValidationArray?.join(','),
                        renderCustomPlaceholder: () => {
                            return (
                                <div className='gibu-inner mx-auto text-center'>
                                    <div className='inline-block mx-auto mb-3'><Icons.UploadIconBlue /></div>
                                    <LanguageTranslator tag="h4" className='!mb-3 text-sm font-semibold text-[#718096]'>Drag & Drop files here</LanguageTranslator>
                                    {/* <LanguageTranslator tag='div' className='generic-approve-btn flex items-center justify-center !h-[34px] !min-w-[200px] !rounded-[5px]'>Choose File</LanguageTranslator> */}
                                    <GenericCustomButton
                                        type='primary'
                                        label={'Choose File'}
                                        style={{ position: 'static' }}
                                        className='mx-auto'
                                    />
                                    {
                                        downloadSampleCustomComponent
                                    }
                                    {/* <LanguageTranslator tag="p" className='mt-[12px] text-[11px] font-medium text-[#718096]'>Maximum Size : Upto 200 MB</LanguageTranslator> */}
                                    {(downloadSampleButtonUrl || downloadSampleCustomFunction) && (<GenericCustomButton
                                        type='underline'
                                        label={props.downloadSampleButtonLoading? <GenericSpinnerLoader size="small"/> : downloadSampleButtonLabel}
                                        leftIcon={props.downloadSampleButtonLoading? null :  <Icons.DownloadDocumentsIcon />}
                                        onClick={() => props.downloadSampleButtonLoading? null : downloadSample()}
                                        disabled={props.downloadSampleButtonLoading}
                                        className={'mx-auto mt-[12px]'}
                                    />)}
                                </div>
                            )
                        }
                    })}
                />

                {/* If the current file is selected then we need to render the file name */}
                {currentFile && <div className='mt-[12x] px-3 py-2.5 w-fit rounded-[5px] flex gap-5 bg-[#F8F8F8]'>
                    <div className="flex gap-2 items-center">
                        <div className='p-[6px] border border-[#D9D9D9] rounded-[5px]'>
                            <Icons.PdfFileIcon />
                        </div>
                        <div>
                            <p className='text-[13px] font-semibold mb-1'>{currentFile?.name || "-"}</p>
                            <p className='mb-0 text-xs font-medium'>{formatFileSize(currentFile?.size)}</p>
                        </div>
                    </div>
                    <GenericCustomButton
                        leftIcon={<Icons.CrossIcon />}
                        onClick={() => { setCurrentFile(null) }}
                        tooltip="Remove File"
                        type="deafult"
                        className='hover:opacity-75'
                    />
                </div>}
            </div>


            <GenericFormFooterComponent
                buttons={[
                    {
                        type: "default",
                        onClick: props.closeModal,
                        label: 'Close'
                    },
                    {
                        type: "primary",
                        onClick: () => submitFile({
                            file : currentFile,
                        }),
                        label: 'Submit',
                        loading: finalSubmitButtonLoading,
                        disabled: () => !currentFile || finalSubmitButtonLoading
                    },
                ]}
            />
        </div>
    )
}

export default FileUpload